import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.funktionsbereich-email-benachrichtigung-fehlerfall';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungFunktionsbereichEMailBenachrichtigungFehlerfallEffects {

    FunktionsbereichEMailBenachrichtigungFehlerfall$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FUNKTIONSBEREICH_EMAIL_BENACHRICHTIGUNG_FEHLERFALL),
        mergeMap((x: ac.PostFunktionsbereichEMailBenachrichtigungFehlerfallAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFunktionsbereichEMailBenachrichtigungFehlerfall(x.funktionsbereichEmpfaengerRequest).pipe(
                map((result: any) => {
                    return new ac.PostFunktionsbereichEMailBenachrichtigungFehlerfallErfolgreichAction(result, x.funktionsbereichEmpfaengerRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFunktionsbereichEMailBenachrichtigungFehlerfallFehlerAction(error, x.funktionsbereichEmpfaengerRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunktionsbereicheCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunktionsbereicheCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunktionsbereicheCommandService);
        }
        return this.service;
    }
}
